export const emptyForm = {
  categoryId: null,
  subCategoryId: null,

  productName: "",
  description: "",
  brand: "",
  modelNumber: "",

  costPrice: null,
  taxRate: null,

  currency: "ETB",
  productCondition: "NEW", // default

  dimensionUnit: "cm",
  weightUnit: "kg",

  returnPolicy: "",
  warrantyPeriod: "",
};

// export const createEmptyVariant = () => ({
//   sku: "",
//   price: "",
//   availableQuantity: "",
//   weight: "",
//   attributes: {},
//   images: [],
//   previews: [],
// });

export const createEmptyVariant = () => ({
  id: null,
  sku: "",
  price: "",
  availableQuantity: "",
  weight: "",
  productCondition: "NEW",
  productStatus: "ACTIVE",
  isDefault: false,
  attributes: {},

  existingImages: [],
  newImages: [],
  previews: [],
  removedImages: [],
});
